export default __webpack_public_path__ + "static/media/13.d7d2d770.png";